// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__52TBK","lastUpdated":"TermsOfService_lastUpdated__1cplt"};